import { backboneModelProperties } from "../../decorators/backbone-properties";
import { prop } from "../../decorators/property";
import { ReelItemModel } from "./reel-item";
import { Container } from "aurelia-dependency-injection";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

@backboneModelProperties({
    relations: [{
        type: Backbone.Many,
        key: "Items",
        relatedModel: ReelItemModel
    }],
    defaults: {
        Items: []
    }
})
export class OverviewReelModel extends Backbone.AssociatedModel {

    @prop() public Title: string;
    @prop() public Items: Backbone.Collection<ReelItemModel>;
    @prop() public Loading = true;
    @prop() public SlideStart = 0;
    @prop() public SearchQuery: string;
    @prop() public Type: string;

    public appEvents = ContainerHelper.Events;
    public user = ContainerHelper.AuthService.AppUser;

    constructor(options?) {
        super(options);
    }

    public loadData() {
        //
    }

    public isPersonalUser() {
        return this.user && !this.user.AuthenticatedByIp && this.user.Email;
    }

    public getFlagValue(flagFile: string): string {
        if (flagFile === undefined) {
            return "";
        }
        return flagFile.replace(".png", "");
    }

    private limitStringLength(text: string, maxLength: number): string {
        const elipsisWidth = 2;
        if (!text || text.length <= maxLength || maxLength < elipsisWidth) {
            return text;
        }
        return text.substring(0, maxLength - elipsisWidth) + "...";
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/overview-reel.ts